import React from 'react';
import { Link } from 'react-router-dom'
import './navbar.css'
import Logo from '../../assets/cosmetinkLogo.png'

class NavBar extends React.Component {
  constructor(props) {
    super(props);
    this.logoutUser = this.logoutUser.bind(this);
    this.getLinks = this.getLinks.bind(this);
  }

  logoutUser(e) {
      e.preventDefault();
      this.props.logout();
  }

  getLinks() {
      if (this.props.loggedIn) {
        return (
          <div className="links">
          <a className="logout" onClick={(e) => this.logoutUser(e)}> Logout</a>
          </div>
        );
      } else {
        return (
            <div className="links">
               
            </div>
        );
      }
  }

  render() {
      return (
        <div className="full-navbar">
            <img className="logo" src={Logo} />
            
            { this.getLinks() }
        </div>
      );
  }
}

export default NavBar;